import { onFieldReact } from '@formily/core';

const REQUIRED_MESSAGE = 'This field is required';

/**
 * Form-level effect: makes `required` count only LIVE items on array fields.
 *
 * Array elements flagged `toBeDeleted: true` do not satisfy `required`. Formily's
 * built-in required sees the raw value — which still holds the tombstoned rows —
 * so a fully-emptied-by-deletion array looks non-empty and passes. This reacts to
 * every field and, when a required field's value is a non-empty array with zero
 * live items, sets an `EffectError` feedback (which marks the form invalid and
 * blocks submit); it clears otherwise.
 *
 * Uses feedback rather than a validator so it COMPOSES with any existing
 * validators instead of replacing them. A genuinely empty value (`[]` / nullish)
 * is left to the built-in required so the message isn't duplicated; non-array
 * values are ignored.
 *
 * Pass as `createForm({ effects: requiredIgnoringDeletedEffect })`.
 */
export const requiredIgnoringDeletedEffect = () => {
  onFieldReact('*', field => {
    const f = field as any;

    if (typeof f.setFeedback !== 'function' || !f.required) return;

    const value = f.value;

    if (!Array.isArray(value)) return;

    const hasLive = value.some((item: any) => !item?.toBeDeleted);

    f.setFeedback({
      type: 'error',
      code: 'EffectError',
      messages: value.length > 0 && !hasLive ? [REQUIRED_MESSAGE] : [],
    });
  });
};
